import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';
import { connect } from 'react-redux';
import listensToClickOutside from 'react-onclickoutside';
import Dropdown from './components/Dropdown';
import Badge from './components/Badge';
import * as actions from './Notification.ducks';
// icons
import NotificationIcon from 'zignal-landscape/lib/Icon/NotificationIcon';
import MfeNavNotificationsIcon from 'zignal-landscape/lib/Icon/MfeNavNotificationsIcon';

const mapStateToProps = (
  (state) => ({
    isOpen: state.Notification.isOpen,
    notifications: state.Notification.notifications,
    unreadCount: state.Notification.unreadCount,
    userId: state.AppUser.user.id,
    total: state.Notification.total,
    offset: state.Notification.offset
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class Notification extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { fetchNotifications, userId, joinNotificationRoom } = this.props;
    fetchNotifications(userId);
    joinNotificationRoom(userId);
  }

  componentWillUnmount() {
    const { leaveNotificationRoom, userId} = this.props;
    leaveNotificationRoom(userId);
  }

  // This method is called by `listensToClickOutside` higher order component
  // to ensure currently opened Notification is closed by clicking outside Notification.
  handleClickOutside() {
    const { isOpen } = this.props;
    if (isOpen) {
      this.updateReadFlag();
      this.props.closeDropdown();
    }
  }

  handleClick() {
    this.updateReadFlag();
    this.props.toggleDropdown();
  }

  updateReadFlag() {
    const { isOpen, unreadCount, userId, updateReadFlag } = this.props;
    if (isOpen && unreadCount > 0) {
      updateReadFlag(userId);
    }
  }

  render() {
    const {
      timezoneOffset,
      isOpen,
      notifications,
      unreadCount,
      fetchNotifications,
      userId,
      total,
      offset,
      parentStyles,
      navigate
    } = this.props;

    if (parentStyles) {
      // Important: classes are being read from coffeescript files to give it style and extra functionality.
      // Do not remove them nor modify the DOM structure.
      const notificationIconClasses = {
        'help-link': true,
        [parentStyles.NavBarButton]: true,
        [parentStyles.NavBarDropDownButtonActive]: isOpen
      };
      return (
        <>
          <div className="help notification-dropdown">
            <div
              className={classnames(notificationIconClasses)}
              onClick={this.handleClick}
            >
              <div className={parentStyles.NavBarButtonContent}>
                <div className={parentStyles.NavBarButtonIcon}>
                  <MfeNavNotificationsIcon height={24} width={24} />
                </div>
              </div>
              <Badge isNewNav unreadCount={unreadCount} />
            </div>
            <Dropdown
              timezoneOffset={timezoneOffset}
              isOpen={isOpen}
              loadMore={() => fetchNotifications(userId)}
              notifications={notifications}
              unreadCount={unreadCount}
              total={total}
              offset={offset}
              navigate={navigate}
              isNewNav
            />
          </div>
        </>
      );
    }
    // Important: classes are being read from coffeescript files to give it style and extra functionality.
    // Do not remove them nor modify the DOM structure.
    return (
      <li className="help notification-dropdown">
        <a className="help-link" onClick={this.handleClick}>
          <span className="title">Notifications</span>
          <span className="notification-icon">
            <NotificationIcon />
          </span>
          <Badge unreadCount={unreadCount} />
        </a>
        <Dropdown
          timezoneOffset={timezoneOffset}
          isOpen={isOpen}
          loadMore={() => fetchNotifications(userId)}
          notifications={notifications}
          unreadCount={unreadCount}
          total={total}
          offset={offset}
          navigate={navigate}
        />
      </li>
    );
  }
}

Notification.propTypes = {
  timezoneOffset: PropTypes.number.isRequired,
  isOpen: PropTypes.bool,
  notifications: PropTypes.array,
  loadMore: PropTypes.func,
  unreadCount: PropTypes.number,
  fetchNotifications: PropTypes.func,
  toggleDropdown: PropTypes.func,
  updateReadFlag: PropTypes.func,
  userId: PropTypes.string,
  closeDropdown: PropTypes.func,
  joinNotificationRoom: PropTypes.func,
  leaveNotificationRoom: PropTypes.func,
  total: PropTypes.number,
  offset: PropTypes.number,
  parentStyles: PropTypes.object,
  navigate: PropTypes.func
};

Notification.defaultProps = {
  notifications: [],
  navigate: noop
};

export default connect(mapStateToProps, actions, mergeProps)(listensToClickOutside(Notification));
